import { stringify } from 'qs';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { stripLastPathSegment } from '../../../helpers/paths';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { icons, IconText } from '../../generic/Icon';
import { RouterLink } from '../../generic/Link';

import styles from './IssueDetails.module.less';

/**
 * BackToIssues is a link which will bring the user back to the issues page.
 * It checks the Redux store to check if there are filters which it can
 * stringify so that the user is linking back with the same filters applied.
 *
 * Previously, we were calling `router.goBack` (same as clicking the back button in the browser),
 * which doesn't work as expected if the user lands directly on the issue details/aren't coming
 * from the issue details page.
 */
const BackToIssues: VoidFunctionComponent = () => {
  const filters = useSelector(
    IssuesV2Store.selectors.getHydrateStateQuery,
  );
  const basePath = stripLastPathSegment(window.location.pathname);
  const backToURL = `${basePath}?${stringify(filters)}`;
  return (
    <div className={styles.backToLink}>
      <RouterLink to={backToURL}>
        <IconText
          icon={icons.angleLeft}
          text="Back to issues"
        />
      </RouterLink>
    </div>
  );
};

export default BackToIssues;
